import Vue from "vue";
import Router from "vue-router";
import routes from "../modules/router";
import { user } from "../helpers";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
});

//check if user is logged in
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth);

  if (requiresAuth && !user.isAuthenticated()) {
    next({ name: "companyUrl" });
  } else {
    next();
  }
});

// check if user has right permissions
router.beforeEach((to, from, next) => {
  const routeHasPermissions = Object.keys(to.meta).includes("permissions");

  if (routeHasPermissions && !user.hasAnyPermission(to.meta.permissions)) {
    next({ name: "Unauthorized" });
  } else {
    next();
  }
});

export default router;
